import React, { createContext, useContext, useState } from 'react';
import AssessmentModal from '../components/AssessmentModal';

const AssessmentContext = createContext();

export const AssessmentProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);

    const openAssessment = () => setIsOpen(true);
    const closeAssessment = () => setIsOpen(false);

    return (
        <AssessmentContext.Provider value={{ openAssessment, closeAssessment }}>
            {children}
            <AssessmentModal isOpen={isOpen} onClose={closeAssessment} />
        </AssessmentContext.Provider>
    );
};

export const useAssessment = () => useContext(AssessmentContext);
